<template>
  <div class="errPage-container">
    <el-row>
      <el-col :span="12">
        <h1 class="text-jumbo text-ginormous">
          抱歉!
        </h1>
        <h2>{{ errorMessage }}</h2>
        <h6>如有需要请联系您领导</h6>
      </el-col>
      <el-col :span="12">
        <img :src="errGif" width="313" height="428">
      </el-col>
    </el-row>

  </div>
</template>

<script>

export default {
    name: 'Page401',
    data() {
        return {
            errGif: '/images/w-imgs/401_images/401.gif?' + +new Date(),
            errorMessage: ''
        }
    },
    created() {
        this.errorMessage = this.$route.query.errorMessage
    },
    mounted() {
        const url = decodeURIComponent(location.href)
        const urlNew = url.split('?')[0]
        window.history.pushState(null, null, urlNew)
    },
    methods: {
        back() {
            if (this.$route.query.noGoBack) {
                this.$router.push({ path: '/dashboard' })
            } else {
                this.$router.go(-1)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
  .errPage-container {
    width: 800px;
    max-width: 100%;
    margin: 100px auto;
    .pan-back-btn {
      background: #008489;
      color: #fff;
      border: none!important;
    }
    .pan-gif {
      margin: 0 auto;
      display: block;
    }
    .pan-img {
      display: block;
      margin: 0 auto;
      width: 100%;
    }
    .text-jumbo {
      font-size: 60px;
      font-weight: 700;
      color: #484848;
    }
    .list-unstyled {
      font-size: 14px;
      li {
        padding-bottom: 5px;
      }
      a {
        color: #008489;
        text-decoration: none;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
</style>
